export default __webpack_public_path__ + "191086c.png";